import { Empty, message, Spin, Tree } from 'antd';
import { isUndefined } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';

import styles from './Member.less';

import type { OrganizationTreeNode } from './MemberNode';
import { OrganizationDataTree } from './MemberNode';
import { getMemberTree } from './request';
import type { Organization, SelectMember } from './type';

interface MemberTreeProps {
  memberNodes: SelectMember[];
  setMemberNodes: (memberNodes: SelectMember[]) => void;
  searchValue?: string;
}

const getAllDataList = (tree: OrganizationTreeNode[]): OrganizationTreeNode[] => {
  const result: OrganizationTreeNode[] = [];
  tree.forEach((item) => {
    result.push(item);
    if (item.childNodes && item.childNodes.length > 0) {
      result.push(...getAllDataList(item.childNodes));
    }
  });
  return result;
};

interface data {
  key: string;
  title: React.ReactNode;
  completeName: string;
  children?: data[];
}

const getAllChildrenNode = (tree: data[]): data[] => {
  const result: data[] = [];
  tree.forEach((item) => {
    result.push(item);
    if (item.children && item.children.length > 0) {
      result.push(...getAllChildrenNode(item.children));
    }
  });
  return result;
};

const MemberTree = ({ memberNodes, setMemberNodes, searchValue }: MemberTreeProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const [treeData, setTreeData] = useState<Organization[]>([]);
  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  const [selectedId, setSelectedId] = useState<string>();
  const dataTree = useMemo(() => {
    return new OrganizationDataTree(treeData);
  }, [treeData]);

  const dataTreeList = useMemo(
    () =>
      getAllDataList(dataTree.nodes)
        .filter((list) => !isUndefined(list.completeName) && !list.hasChildren)
        .filter(
          (item) =>
            (item?.title.toLowerCase() || '').indexOf(searchValue?.toLowerCase() || '') > -1,
        )
        .map((elem) => {
          const strTitle = elem.title || '';
          const index = strTitle.toLowerCase().indexOf(searchValue?.toLowerCase() || '');
          const beforeStr = strTitle.substring(0, index);
          const afterStr = strTitle.slice(index + (searchValue || '').length);
          const title =
            index > -1 ? (
              <span>
                {beforeStr}
                <span className={styles.siteTreeSearchValue}>
                  {strTitle.slice(index, index + (searchValue || '').length)}
                </span>
                {afterStr}
              </span>
            ) : (
              <span>{strTitle}</span>
            );
          return {
            key: elem.key,
            isUser: true,
            title: title as React.ReactNode,
            completeName: elem.completeName,
            children: [],
          };
        }),
    [dataTree.nodes, searchValue],
  );

  const checkedKeysValue = useMemo(() => memberNodes.map((item) => item.id), [memberNodes]);

  useEffect(() => {
    const getMemberTreeRun = () =>
      getMemberTree().then((data) => {
        setTreeData([data.data]);
        setIsLoading(false);
      });

    getMemberTreeRun();
  }, []);

  return isLoading ? (
    <div className={styles.empty}>
      <Spin tip="Loading" size="default">
        <div className="content" />
      </Spin>
    </div>
  ) : (searchValue && dataTreeList.length > 0) || (!searchValue && dataTree.data.length > 0) ? (
    <Tree
      checkable
      checkedKeys={checkedKeysValue}
      treeData={searchValue ? dataTreeList : dataTree.data}
      selectedKeys={[selectedId || '']}
      expandedKeys={expandedKeys}
      autoExpandParent={autoExpandParent}
      onSelect={(_selectedKeys, { selected, node }) => {
        console.log('node是');
        console.log(node);
        if (selected) {
          setExpandedKeys([...expandedKeys, node.key]);
          setSelectedId(node.key);
        } else {
          setExpandedKeys(expandedKeys.filter((item) => item !== node.key));
          setSelectedId(void 0);
        }
      }}
      onExpand={(newExpandedKeys) => {
        setExpandedKeys(newExpandedKeys);
        setAutoExpandParent(false);
      }}
      onCheck={(_checkedKeys, { checked, node }) => {
        if (checked) {
          console.log('onCheck node是');
          console.log(node);
          if (node.children && node.children.length > 0) {
            setMemberNodes([
              ...memberNodes,
              ...getAllChildrenNode([node])
                .filter((item) => !item.children || item.children.length === 0)
                .filter((tempNode) => !memberNodes.map((it) => it.id).includes(tempNode.key || ''))
                .map((elem) => {
                  return {
                    id: elem.key?.toString(),
                    completeName: elem.completeName,
                  };
                }),
            ]);
          } else {
            if (!node.isUser) {
              message.warning('组织下无成员，无法选择');
            } else {
              setMemberNodes([...memberNodes, { id: node.key, completeName: node.completeName }]);
            }
          }
        } else {
          setMemberNodes(
            memberNodes.filter(
              (item) =>
                !getAllChildrenNode([node])
                  ?.map((elem) => elem.key)
                  ?.includes(item.id),
            ),
          );
        }
      }}
    />
  ) : (
    <Empty
      description={<div style={{ color: '#C0C0C0' }}>未找到结果，换个关键词试试吧</div>}
      image={
        <img src="https://hwobs.fanruan.com/ui/search.png" style={{ width: 160, height: 160 }} />
      }
      imageStyle={{ height: 160 }}
    />
  );
};
export default MemberTree;
